
import React from "react";
import "./sun.css";

// import ReactTransitionGroup from 'react-addons-transition-group'
// import TransitionGroup from 'react-transition-group/TransitionGroup'

class Sun extends React.Component {

  render() {
    return (<div className="badge">
        
    </div>)
  }

};

export default Sun;


// WEBPACK FOOTER //
// ./src/components/sun/sun.js